import React, { useCallback } from 'react';
import { useSuspenseConstructionProject } from '@/clients/constructionProject/useConstructionProject.ts';
import { usePositionContext } from '@/shared/context/PositionContext.tsx';
import { PositionSettingsForm } from '@/shared/forms/PositionSettingsForm/PositionSettingsForm.tsx';
import { PositionSettingsFormValues } from '@/shared/forms/PositionSettingsForm/schemas/getPositionSettingsFormSchema.ts';

export type PositionSettingsValues = Pick<PositionSettingsFormValues, 'active' | 'note'> &
    Pick<PositionSettingsFormValues['dateRange'], 'validFrom' | 'validTo'>;

type PositionSettingsProps = {
    onContinue: () => void;
};

export function PositionSettings({ onContinue }: PositionSettingsProps) {
    const { isEditing, contextData } = usePositionContext();

    const defaultValues = contextData.getFormData();
    const customerInfo = contextData.getCustomerInformation();

    if (!customerInfo) {
        throw new Error('Customer information is required to render PositionSettingsForm.');
    }

    const { data: constructionProject } = useSuspenseConstructionProject(customerInfo.constructionProjectId);

    const handleSubmitPositionSettingsForm = useCallback(
        (positionSettings: PositionSettingsValues) => {
            contextData.setFormData(positionSettings);
            onContinue();
        },
        [contextData, onContinue]
    );

    return (
        <PositionSettingsForm
            projectTitle={constructionProject.name}
            defaultValues={defaultValues}
            formRules={{
                dateRange: { validFrom: constructionProject.validFrom, validTo: constructionProject.validTo },
            }}
            onSubmit={handleSubmitPositionSettingsForm}
            mode={isEditing ? 'edit' : 'create'}
        />
    );
}
